import type { ReactNode } from "react";

// 页面头部(迁移自 key-health-check):eyebrow(大写/字距/蓝灰)+ 标题 + 描述 + 可选操作。
export function PageHeader({
  eyebrow,
  title,
  description,
  action,
}: {
  eyebrow: string;
  title: string;
  description?: string;
  action?: ReactNode;
}) {
  return (
    <div className="mb-7 flex flex-wrap items-end justify-between gap-4">
      <div className="min-w-0">
        <p className="mb-1 text-[10px] font-extrabold tracking-[.18em] text-[#5577b7] uppercase">{eyebrow}</p>
        <h1 className="m-0 text-[clamp(24px,2.2vw,32px)] font-semibold tracking-[-.02em] text-[#111b2e]">{title}</h1>
        {description && <p className="mt-1.5 text-[13px] text-[#78859a]">{description}</p>}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}